import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { LcsResponsiveTableModule } from '@lcs/shared/table';
import { IconsModule } from 'src/app/common-components/icons/icons.module';
import { FormatPhoneNumbersPipeModule } from 'src/app/pipes/format-phone-numbers/format-phone-numbers-pipe.module';
import { FormatSecondsPipeModule } from 'src/app/pipes/format-seconds/format-seconds-pipe.module';
import { AddSpacesPipeModule } from 'src/app/pipes/split-enum-strings/add-spaces-pipe.module';
import { OutgoingFaxDetailDialogComponent } from './outgoing-fax-detail-dialog.component';

@NgModule({
   declarations: [OutgoingFaxDetailDialogComponent],
   imports: [
      CommonModule,
      MatDialogModule,
      MatButtonModule,
      MatExpansionModule,
      MatIconModule,
      IconsModule,
      FormatPhoneNumbersPipeModule,
      FormatSecondsPipeModule,
      LcsResponsiveTableModule,
      AddSpacesPipeModule,
   ],
   providers: [OutgoingFaxDetailDialogComponent, DatePipe],
})
export class OutgoingFaxDetailDialogModule {}
